// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/scss/woocommerce/woocommerce.scss
// module id = ./resources/scss/woocommerce/woocommerce.scss
// module chunks = 0